export const EstadoCivilArray =[
    {id:'SO',display:'SOLTERO'},
    {id:'CA',display:'CASADO'},
    {id:'UN',display:'UNION LIBRE'},
    {id:'VI',display:'VIUDO'},
    {id:'DI',display:'DIVORCIADO'},
]

const estadoCivilArrayMayusculas = EstadoCivilArray.map(item => {
    return {
        id: item.id,
        display: item.display.toUpperCase()
    };
});

export { estadoCivilArrayMayusculas };